/* Filthy Clean — TEMPORARY, part of the 🧺 Facebook ad campaign (added 2026-09-25).
   To remove with the rest of the promo: delete this file and its <script> tag in
   the fc_styles section of header-group.json.

   Why it exists: the ad code discounts ONE-TIME purchases of the three sheet
   products and the Starter Pack only. Loop preselects Subscribe, and a cart-level
   code is invisible on a product page, so an ad visitor sees "Subscribe $28.49"
   sitting next to "One-Time $29.99" and picks the option that looks cheaper while
   actually costing them $7.49 more (one-time is $21.00 once the code applies).
   This preselects One-Time for ad visitors, and only for them.

   Guard rails, in order of importance:
   - Runs only when html.fc-promo-visitor is set, i.e. the banner's inline script
     confirmed the ad discount is genuinely live on this session. Ordinary traffic
     keeps Subscribe as the default, untouched.
   - Runs only on the four products the discount actually covers.
   - Fires at most once per page load, and never once the customer has touched the
     purchase options, so a deliberate Subscribe choice is never overridden.

   Loop's widget is third-party DOM. If these class names change the flip simply
   stops happening, which falls back to today's behaviour rather than breaking. */
(function () {
  'use strict';

  var HANDLES = [
    'laundry-detergent-sheets',
    'dishwashing-detergent-sheets',
    'toilet-cleaning-sheets',
    'the-filthy-clean-starter-pack'
  ];

  /* Wholesale (B2B) buyers never get the promo: the fc_promo section returns early
     for them, so fc-promo-visitor is never set. Spelled out here as well. */
  if (document.documentElement.classList.contains('fc-b2b')) return;
  if (!document.documentElement.classList.contains('fc-promo-visitor')) return;

  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  if (HANDLES.indexOf(handle) === -1) return;

  var OPTIONS = '.loop-widget-purchase-options-container';
  var ONETIME = '.loop-widget-purchase-option-onetime';
  var done = false;

  /* Capture phase, so the customer's intent is recorded even though Loop handles
     the same event itself. Once they've touched the options, we stay out. */
  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.target && e.target.closest && e.target.closest(OPTIONS)) done = true;
    },
    true
  );

  function flip() {
    if (done) return;
    var onetime = document.querySelector(ONETIME);
    if (!onetime) return; // widget hasn't rendered yet
    done = true;
    if (onetime.getAttribute('aria-checked') !== 'true') onetime.click();
  }

  flip();
  if (done) return;

  /* Loop injects the widget after load, so watch for it. The timeout stops us
     leaving an observer running on a page whose widget never arrives. */
  var observer = new MutationObserver(function () {
    flip();
    if (done) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
